import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { get, set, remove, isEmpty, sortBy, findIndex,orderBy,cloneDeep,isEqual,differenceWith,groupBy } from 'lodash';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { SegmentService } from '@ispm-client/modules/segments/services/segments.service';
import { Findings } from '@ispm-client/modules/segments/interfaces';
import { Subject, Observable, of } from 'rxjs';
import { DynamicFormTableComponent } from '@ispm/dynamic-form/components/dynamic-form-table/dynamic-form-table.component';
import { FindingsService } from '@ispm-client/modules/segments/services/findings.service';
import { connectorObservable, deletedField, componentInitialized, componentDestroyed } from '@ispm-client/modules/segments/interfaces/constants';
import { AbstractControl, AsyncValidator, FormGroup, ValidationErrors } from '@angular/forms';




@Component({
  selector: 'ispm-segment-findings-table',
  templateUrl: './segment-findings-table.component.html',
  styleUrls: ['./segment-findings-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('findingsTable')
export class SegmentFindingsTableComponent implements OnInit, IWidgetItem {

  public initChange: boolean = false;
  public itemName: string;
  public widgetFormInstance: FormGroup;
  public valid: boolean = true;
  public disabled: any;

  constructor(private segmentService: SegmentService,
              private findingService: FindingsService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  set widgetData(widgetData: any) {
    if (!isEmpty(widgetData) && JSON.stringify(widgetData) != this.data) {
      this.data = widgetData;
      if (!this.data) {
        this.data = [];
      }
      this.formData = this.mapWidgetData(widgetData,false);
      if(!this.skipSorting){
      this.formData = orderBy(this.formData, object => +object.index);
      }
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.markForCheck();
    }
  }

  set widgetConfig(config: IdynamicFormItem) {
    this.payload = config.widgetPayload;
    this.itemName = config.name;
    this.connectorEmitter = this.segmentService.getObservable(connectorObservable, true);
    if(this.connectorEmitter){
      this.connectorEmitter.next(componentInitialized);
    }
    if(this.payload.groupByKey){
      this.groupByKey=this.payload.groupByKey;
    }
    if(this.payload.groupByDelKeys){
      this.groupByDelKeys=this.payload.groupByDelKeys;
    }
    if(this.payload.groupByDelRows){
      this.groupByDelRows=this.payload.groupByDelRows;
    }
    if (this.payload.findingsObservableName) {
      this.findingsEmitter = this.segmentService.getObservable(this.payload.findingsObservableName, true);
    }
    if (this.payload.segmentsObservableName) {
      this.findingsObserver = this.segmentService.getObservable(this.payload.segmentsObservableName, true);
      this.findingsObserver
        .takeUntil(this.destroyer)
        .filter(segmentsData => !isEmpty(segmentsData))
        .subscribe(segmentsData => {
          this.payload['skipInitUpdate'] = false;
          const filterData = this.mapWidgetData(segmentsData);
          this.formData = [...filterData];
          this.changeDetectorRef.detectChanges();
          this.changeDetectorRef.markForCheck();
        });
    }
    this.payload = Object.assign({}, this.payload, { viewAsTable: get(this.payload, 'viewAsTable', true)});
    this.payload = Object.assign({}, this.payload, { tableVertical: get(this.payload, 'tableVertical', true)});
    this.payload = Object.assign({}, this.payload, { formVertical: get(this.payload, 'formVertical', false)});
    this.payload['skipInitUpdate'] = true;
    this.skipSorting = get(this.payload, 'attributes["[skipSorting]"]', false);

    if (this.widgetFormInstance && !this.payload.disabled) {
      this.disabled = get(this.widgetFormInstance, 'disabled', false);
    }
  }
  private static UNIQUE_ID: string = '__gen-selection-list__unique-item-id__';

  @Input() payload: any;
  @Input() data: any;
  skipSorting: boolean;
  public widgetUpdateValueCallback: (value) => void;
  formData: any =[];
  findingsEmitter: Subject<any>;
  findingsObserver: Observable<any>;
  //this field allows to group-by rows
  groupByKey:string ;
  //this field tells which fields need to be discarded sub fileds of groupby rows
  groupByDelKeys:string ;
  groupByDelRows:boolean ;
  connectorEmitter: Subject<any>;
  findings: Findings = { itemDeleted: '', data: []};
  private destroyer: Subject<any> = new Subject();

  ngOnInit() {

  }

  mapWidgetData(data,updateWidget=true) {
    if (!this.skipSorting) {
    data = orderBy(data.filter(item => item[deletedField] !== true || (item[deletedField] !== true && !item['id'])), object => +object.index);
    }
    data.map(dataItem => {
      if (dataItem['newItem']) {
        delete dataItem['newItem'];
        const addEvent = { dataArray: data, item: dataItem};
        this.handleAddEvent(addEvent);
      }
    });
    let tempData;
    if (!this.skipSorting) {
      data = this.indexUpdate(data);
      tempData = orderBy(data.filter(item => item[deletedField] !== true || (item[deletedField] !== true && !item['id'])), object => +object.index);
    } else {
      tempData = data;
    }
    if (this.widgetUpdateValueCallback && updateWidget) {
      this.widgetUpdateValueCallback.apply(this, [tempData]);
    }
    if(this.groupByKey){
      let groupByData=[];
      let intermittentData=groupBy(tempData,(data=>get(data,this.groupByKey)));
      for (let intermittentDataKey in intermittentData) {
        if (this.groupByDelKeys) {
          let uniqueGroupByArray = intermittentData[intermittentDataKey];
          let delKeyArray=this.groupByDelKeys.split(",");
          for(let delKey of delKeyArray){
            for (let i=0;i<uniqueGroupByArray.length;i++){
              let delKey1=`dup${delKey}`;
              uniqueGroupByArray[i][delKey1]=uniqueGroupByArray[i][delKey];
              if(i!=0)
                uniqueGroupByArray[i][delKey]=null;
            }
          }
          groupByData.push(...uniqueGroupByArray);
        }
        if (this.groupByDelRows) {
          let uniqueGroupByArray = intermittentData[intermittentDataKey];
          groupByData.push(uniqueGroupByArray[0]);
        }
      }
      tempData=[].concat(groupByData);
    }
    return tempData;
  }

  /**
   * This function uses the validationStatus to calculate the validaty of the table
   * @param {boolean[]} validationStatus
   */
  validationStatusRef = (validationStatus: boolean[]) => {
    this.valid = validationStatus.every(v => !!v);
    this.runAsyncValidator();
    this.widgetFormInstance.controls[this.itemName].patchValue(this.widgetFormInstance.controls[this.itemName].value, { emitEvent: true });
  }

  /**
   * function to emit the deleted data
   * @param deleteData
   */
  deleteItemHanlder(deleteData) {
    this.payload['skipInitUpdate'] = false;
    const itemPath = 'item.';
    remove(this.data, (originalData) => {
      return this.compareItems(originalData, deleteData.item);
    });
    if (deleteData.item) {
      deleteData.item[deletedField] = true;
    }
    if (!this.data) {
      this.data = [];
    }
    this.data.pushIfNotExist(deleteData.item, (orgData) => {
      return this.compareItems(orgData, deleteData.item);
    });
    const formIndexedData = this.indexUpdate(deleteData.dataArray);
    this.formData = cloneDeep(formIndexedData);
    this.formData.forEach(formDataItem => {
      const formIndexData = formIndexedData.find(indexedData => indexedData['index'] === formDataItem['index']);
      const genUniqueId = formIndexData[SegmentFindingsTableComponent.UNIQUE_ID];
      Object.defineProperties(formDataItem, {
        [SegmentFindingsTableComponent.UNIQUE_ID]: {
          value: genUniqueId,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    })

    this.findings.itemDeleted = deleteData.item;
    this.findings.data = deleteData.dataArray;
    if(this.findingsEmitter){
      this.findingsEmitter.next(this.findings);
    }
    this.emitUpdate();
    this.payload['skipInitUpdate'] = true;
  }

  /**
   * function to emit the Updated data
   * @param data
   */
  handleUpdateEvent(updatedData) {
    this.formData = this.indexUpdate(updatedData)
    this.findings = { itemDeleted: null, data: []};

    if (this.valid && this.findingsEmitter) {
      this.findings['data'] = this.formData;
      this.findingsEmitter.next(this.findings);
    }
    this.updateInOriginalData();
    this.emitUpdate();
    this.payload['skipInitUpdate'] = true;
  }

  /**
   * This method manages the add event information
   */
  handleAddEvent(addEvent) {
    this.formData=sortBy(this.formData.filter(item => item[deletedField] !== true || (item[deletedField] !== true && !item['id'])), 'index');
    this.payload['skipInitUpdate'] = false;
    if (addEvent.dataArray.length === 1) {
      this.findingService.addContext(this.payload.payloadBindings, addEvent.item);
    } else {
      this.findingService.cloneContextForAddItem(addEvent.dataArray, addEvent.item);
    }
    /**
     * This had be handled here as before add initial data had to be set
     */
    // this.formData.push(addEvent.item);
    /*this.formData.pushIfNotExist(addEvent.item, (existingData) => {
      this.compareItems(existingData, addEvent.item);
    });*/
    this.indexUpdate(this.formData);
  }

  indexUpdate(formData){
    formData.map(dataItem => {
      if (!get(dataItem, 'index') || (formData &&(formData.indexOf(dataItem) + 1) != dataItem['index'])) {
        set(dataItem, 'index', formData.indexOf(dataItem) + 1);
        dataItem['index'] = cloneDeep(dataItem['index']);
      }
    });
    return formData;
  }

  /**
   * This calls the call back function provided by the widget to update the data into the formInstance of the Widget Component.
   * Therefore if the corresponding dynamic which loads the widget would have subscribed to the changes in the widget.
   */
  emitUpdate() {
    this.removeScreenItemsDeleted();
    if(this.initChange && this.payload['skipInitUpdate']){
      return;
    }
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this.data]);
    }
  }

  /**
   * This function removes the items from original data which are added
   * from screen and they were not persisted .
   */
  removeScreenItemsDeleted() {
    remove(this.data, (originalData) => {
      return originalData[deletedField] == true && !originalData['id'];
    });
    remove(this.formData, (originalData) => {
      return originalData[deletedField] == true && !originalData['id'];
    });
  }

  /**
   * Update the original data by deleting the old data by comparing the items in data.
   * And push the items from data back to original data .
   */
  updateInOriginalData() {
    if (this.formData) {
      this.formData.forEach(itemData => {
          remove(this.data, (originalData) => {
            return this.compareItems(originalData, itemData);
          });
          if (!this.data) {
            this.data = [];
          }
          this.data.pushIfNotExist(itemData, (existingData) => {
            this.compareItems(existingData, itemData);
          });
        }
      );
    }
  }

  public getItemNgClass(item) {
    // Applying highlight through styles for the stored item
    let highlightItem = { };
    if (item && item.highlight === true && this.payload.showHighlighter === true) {
      highlightItem = item;
      Object.defineProperty(item, DynamicFormTableComponent.ITEM_SPECIFIC_NG_CLASS_PROPRTY, {
        value: this.itemNgClass(highlightItem), enumerable: false,
        configurable: true
      });
      setTimeout(function () {
        highlightItem['highlight'] = false;
        Object.defineProperty(item, DynamicFormTableComponent.ITEM_SPECIFIC_NG_CLASS_PROPRTY, {
          value: this.itemNgClass(highlightItem), enumerable: false,
          configurable: true
        });
      }.bind(this), 3000);
    }
    return null;
  }


  itemNgClass (item: any) {
    let ngClass;
    ngClass = { 'dynamic-form-item-highlight': item.highlight};


    if (! ngClass) {
      ngClass = { };
    }

    return ngClass;
  }

  /**
   * This function compares the items based upon their unique Id property .
   * @param firstItem
   * @param secondItem
   * @returns {boolean}
   */
  compareItems(firstItem, secondItem) {
    if (firstItem[`${SegmentFindingsTableComponent.UNIQUE_ID}`] == secondItem[`${SegmentFindingsTableComponent.UNIQUE_ID}`]) {
      return true;
    }
    return false;
  }

  /**
   * This is required when a external component has subscribed to the data and
   * the current component would be destroyed,so unsaved data in component which was emitted to external component needs to cleaned before destroy.
   */
  cleanUpComponentDataEmission(){
    if(!isEmpty(this.formData)){
      const deleteItems = this.formData.filter(formDataItem => !formDataItem.hasOwnProperty('id'));
      const retainItems = differenceWith(this.formData, deleteItems, isEqual)
      this.findings = { itemDeleted: deleteItems, data: retainItems};
      if(this.findingsEmitter)
        this.findingsEmitter.next(this.findings);
    }
  }

  ngOnDestroy(): void {
    this.cleanUpComponentDataEmission();
    this.segmentService.dismissObservable(this.payload.segmentsObservableName);
    this.segmentService.dismissObservable(this.payload.findingsObservableName);
    this.connectorEmitter.next(componentDestroyed);
    this.destroyer.next();
    this.destroyer.complete();
  }

  addHandler(item) {
    if(findIndex(this.formData,(value) => isEmpty(value)) == -1) {
      this.formData.push(item)
    }
    this.indexUpdate(this.formData);
  }

  runAsyncValidator() {
    if (this.widgetFormInstance.controls[this.itemName] && !(this.widgetFormInstance.controls[this.itemName].asyncValidator)) {
      const asyncValidate = new SegmentTableComponentValidator(() => this.widgetValidator());
      this.widgetFormInstance.controls[this.itemName].setAsyncValidators([asyncValidate.validate.bind(asyncValidate)]);
    }
  }

  /**
   * This the callback function used for the validation in the async validation
   * @returns {boolean}
   */
  widgetValidator(): boolean {
    return  this.valid;
  }


  /**
   * This calls the call back function provided by the widget to update the data into the formInstance of the Widget Component.
   * Therefore if the corresponding dynamic which loads the widget would have subscribed to the changes in the widget.
   */
}

class SegmentTableComponentValidator implements AsyncValidator {

  constructor(
    private validationCallback: () => boolean
  ) {
  }

  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    return this.validationCallback() ? of(null) : of({ error: true });
  }

  registerOnValidatorChange?(fn: () => void): void {
    throw new Error('Method not implemented.');
  }
}
